module.exports = __webpack_public_path__ + "static/media/Recurso 3.affcc209.svg";